import { render } from "./SigninOverlay.vue?vue&type=template&id=101e94b0&scoped=true"
import script from "./SigninOverlay.vue?vue&type=script&lang=js"
export * from "./SigninOverlay.vue?vue&type=script&lang=js"

import "./SigninOverlay.vue?vue&type=style&index=0&id=101e94b0&lang=scss&scoped=true"

import exportComponent from "/Users/zhanglinjun/Downloads/genescloud_wechat-master-d167e5133fddc18883d58aba5b516d53ee974944/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-101e94b0"]])

export default __exports__